module.exports = __webpack_public_path__ + "static/media/raiff-screen03.e1e72804.jpg";